import React, { useEffect, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import ShipmentDocument from '../../../resources/files/ShipmentDoc.pdf';
import Loading from '../../../components/loading/Loading';
import './CompassProApplication.css';

const CompassProApplication = () => {
  const [adobeReady, setAdobeReady] = useState(false);

  useEffect(() => {
    if (window.AdobeDC) {
      initializeAdobeViewer();
    } else {
      document.addEventListener('adobe_dc_view_sdk.ready', () => {
        initializeAdobeViewer();
      });
    }

    return () => {
      document.removeEventListener(
        'adobe_dc_view_sdk.ready',
        initializeAdobeViewer,
      );
    };
  }, []);

  const initializeAdobeViewer = () => {
    try {
      const adobeDCView = new window.AdobeDC.View({
        clientId: import.meta.env.VITE_ADOBE_EMBED_PDF_KEY,
        divId: 'adobe-dc-view',
      });

      adobeDCView.previewFile(
        {
          content: { location: { url: ShipmentDocument } },
          metaData: { fileName: 'ShipmentDoc.pdf' },
        },
        { embedMode: 'FULL_WINDOW' },
      );

      setAdobeReady(true);
    } catch (error) {
      console.error('Error initializing Adobe PDF viewer:', error);
    }
  };

  return (
    <div className="pdf-fullscreen-container">
      {!adobeReady && <Loading loadingText={'Loading PDF viewer...'} />}
      <div id="adobe-dc-view" className="pdf-fullscreen-iframe"></div>
    </div>
  );
};

export default withAuthenticationRequired(CompassProApplication, {
  onRedirecting: () => <Loading loadingText={'Loading...'} />,
});
